module.exports = __webpack_public_path__ + "ff8db38a.svg";